import './assets/main.css'
import { i18n } from '@/i18n'

import { createSSRApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'
import AppRouterLink from '@/components/AppRouterLink.vue'
import { createVuesticEssential } from 'vuestic-ui'
import vuesticConfig from '../vuestic.config'
import { useMiddleware } from '@/router/middleware'
import Config from '@/utils/config'

export const createApp = (request?: any) => {
  /**
   * use createSSRApp to render the Vue App on the server
   * and send it to the user to do the hydration process
   */
  const app = createSSRApp(App)

  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(pinia)
  app.use(router)
  useMiddleware(router)
  const acceptLanguage = request?.headers['accept-language']
  const languageCookie = request?.cookies?.language
  app.use(i18n(request?.url, languageCookie, acceptLanguage), {})
  app.use(createVuesticEssential({
    config: vuesticConfig,
  }))

  app.component('RouterLink', AppRouterLink)

  if (!Config.ssr) {
    const html = document.documentElement
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    html.classList.toggle('dark', isDark)
  }

  return {
    app,
    router,
  }
}
